import React from "react";
import "./TermsAndConditions.css";
import TermsCondition from "../../assets/TermsCondition.jpg";
import Footer from "../Footer/Footer";
const TermsAndConditions = () => {
  return (
    <div>
      <div className="terms-page">
        <div className="terms-banner">
          <img src={TermsCondition} alt="Terms Banner" className="banner-img" />
          <div className="banner-overlay">
            <h1>Terms&Conditions</h1>
          </div>
        </div>
        <div class="privacy-policy-container">
          {/* <div class="line"></div> */}
          <h2 class="privacy-policy-title">
            <span class="blue">Privacy</span> <span class="pink">Policy</span>
          </h2>
          {/* <div class="line"></div> */}
        </div>

        <div className="terms-content">
          <p>
            <strong>
              This Privacy Policy applies to the Varanous Research Pvt. Ltd.:
            </strong>{" "}
            Varanous.com recognizes the importance of maintaining your privacy.
            We value your privacy and appreciate your trust in us. This Policy
            describes how we treat user information we collect on
            https://VaranousLabs.com and other offline sources. This Privacy
            Policy applies to current and former visitors to our website and to
            our online customers. By visiting and/or using our website, you
            agree to this Privacy Policy.
          </p>
          {/* 
        <p>
          Varanouslabs.com is a property of Varanous Research Private Limited, an Indian Company registered
           under the Companies Act, 2014 having its registered
            address at Plot No. F, Shree Ganesh Industrial 
           
        </p> */}

          <h3>InformationWeCollect</h3>
          <p>
            <strong>Contact information:</strong> We might collect your name,
            email, mobile number, phone number, street, city, state, Pincode,
            country and IP address.
          </p>

          <p>
            <strong>Information you post:</strong> We collect the information
            you post in a public space on our website or on a third-party social
            media site belonging to VaranousLabs.com.
          </p>

          <p>
            <strong>Demographic information:</strong> We may collect demographic
            information about you, events you like, events you intend to
            participate in, tickets you buy, or any other information provided
            by you during the use of our website. We might collect this as a
            part of a survey also.
          </p>

          <h3>Other information</h3>
          <p>
            If you use our website, we may collect information about your IP
            address and the browser you're using. We might look at what site you
            came from, the duration of time spent on our website, pages accessed
            or what site you visit when you leave us. We might also collect the
            type of mobile device you are using, or the version of the operating
            system your computer or device is running.
          </p>

          <h3>We collect information in different ways</h3>
          <p>
            <strong>We collect information directly from you:</strong> We
            collect information directly from you when you register for an
            event. We also collect information if you post a comment on our
            websites or ask us a question through phone or email.
          </p>

          <p>
            <strong>We collect information from you passively:</strong> We use
            tracking tools like Google Analytics, Google Webmaster, browser
            cookies, and web beacons for collecting information about your usage
            of our website.
          </p>

          <p>
            <strong>We get information about you from third parties:</strong>{" "}
            For example, if you use an integrated social media feature on our
            websites. The third-party social media site will give us certain
            information about you. This could include your name and email
            address.
          </p>

          <h3>Use of your personal information</h3>
          <p>
            <strong>We use the information to contact you:</strong> We might use
            the information you provide to contact you for confirmation of a
            purchase on our website or for other promotional purposes.
          </p>

          <p>
            <strong>
              We use the information to respond to your requests or questions:
            </strong>{" "}
            We might use your information to confirm your registration for an
            event or feedback.
          </p>

          <p>
            <strong>
              We use the information to improve our products and services:
            </strong>{" "}
            We might use your information to customize your experience with us.
            This could include displaying content based on your preferences.
          </p>

          <p>
            <strong>
              We use information to look at site trends and customer interests:
            </strong>{" "}
            We may use your information to make our website and products better.
            We may combine information we get from you with information about
            you we get from third parties.
          </p>

          <p>
            <strong>We use the information for security purposes:</strong> We
            may use the information to protect our company, our customers, or
            our websites.
          </p>

          <p>
            <strong>We use the information for marketing purposes:</strong> We
            might send you information about special promotions or offers. We
            might also tell you about new features or products. These might be
            our own offers or products, or third-party offers or products we
            think you might find interesting.
          </p>

          <p>We use information as otherwise permitted by law.</p>
          {/* 
        <h3>Third-party sites</h3>
        <p>
          If you click on one of the links to third-party websites, you may be taken to websites we do not control. This policy does not apply to the privacy practices of those websites. Read the privacy policy of other websites carefully. We are not responsible for these third-party sites.
        </p> */}

          <h3>Contact Information</h3>
          <p>
            If you have any questions about this Policy or other privacy
            concerns, you can email us at{" "}
            <a href="mailto:bd@varanouslabs.com">bd@varanouslabs.com</a>
          </p>

          <h3>Jurisdiction</h3>
          <p>
            If you choose to visit the website, your visit and any dispute over
            privacy is subject to this Policy and the website's terms of use. In
            addition to the foregoing, any disputes arising under this Policy
            shall be governed by the laws of India.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
